// eslint-disable-next-line
import i18n from "../../components/i18n";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getCsrfToken } from "../../components/csrf";

function Pandin() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  var pandinItems = t("Pandin", { returnObjects: true });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [feedbackKey, setFeedbackKey] = useState("");
  const [feedbackData, setFeedbackData] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showFeedback, setShowFeedback] = useState(false);
  const feedbackTimeout = useRef(null);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  // Exibe feedback suavemente quando feedbackKey ou feedbackData mudam
  useEffect(() => {
    if (feedbackKey || feedbackData) {
      setShowFeedback(true);
    } else {
      setShowFeedback(false);
    }
    return () => {
      if (feedbackTimeout.current) clearTimeout(feedbackTimeout.current);
    };
  }, [feedbackKey, feedbackData]);

  // Função para esconder feedback suavemente
  const handleCloseFeedback = () => {
    setShowFeedback(false);
    feedbackTimeout.current = setTimeout(() => {
      setFeedbackKey("");
      setFeedbackData("");
    }, 300); // Tempo igual ao da transição CSS
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedbackKey("");
    setFeedbackData("");
    setAlertType("");
    try {
      const csrfToken = await getCsrfToken();
      console.log("CSRF Token:", csrfToken);
      if (!csrfToken) {
        setFeedbackKey("LoginError");
        setFeedbackData("");
        setAlertType("danger");
        return;
      }
      const response = await fetch("http://localhost:8000/pandin", {
        method: "POST",
        credentials: "include",
        headers: {
          "X-CSRF-TOKEN": csrfToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (data.success) {
        setFeedbackKey("LoginSuccess");
        setFeedbackData(data.message || "");
        setAlertType("success");
        // Redireciona para o dashboard após 1 segundo
        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      } else if (data.error_code === 403) {
        setFeedbackKey("InactiveUserError");
        setFeedbackData(data.error_message || "");
        setAlertType("danger");
      } else if (data.error_code === 401) {
        setFeedbackKey("LoginError");
        setFeedbackData(data.error_message || "");
        setAlertType("warning");
      } else {
        setFeedbackKey("");
        setFeedbackData(
          data.error_message || data.message || JSON.stringify(data)
        );
        setAlertType("info");
      }
    } catch (err) {
      setFeedbackKey("LoginError");
      setFeedbackData("");
      setAlertType("danger");
    }
  };

  return (
    <div className="container-fluid pandin py-5 pb-3 mt-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 d-flex flex-column justify-content-center align-items-center first-section">
            <div className="col-12 d-flex justify-content-center title-container">
              <div className="title-row d-flex align-items-center justify-content-center">
                <div className="title">{pandinItems.Title}</div>
                <div className="animation-container-title"></div>
              </div>
            </div>
            <div className="col-12 text-center text-white-70 mt-2 mb-4 fs-5">
              {pandinItems.Subtitle}
            </div>
          </div>
          <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-4 second-section">
            <form className="pandin-login-form" onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label text-white">
                  Email
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label text-white">
                  {pandinItems.PasswordLabel}
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button type="submit" className="btn btn-primary w-100 mt-2">
                {pandinItems.LoginButton}
              </button>
              <div className="login-actions">
                <button type="button" className="btn btn-link">
                  {pandinItems.ForgotPassword}
                </button>
                <button type="button" className="btn btn-link">
                  {pandinItems.CreateAccount}
                </button>
              </div>
              {(feedbackKey || feedbackData) && (
                <div
                  className={`alert mt-3 text-center alert-${
                    alertType || "info"
                  } position-relative fade-feedback${
                    showFeedback ? " show" : ""
                  }`}
                  style={{ transition: "opacity 0.3s" }}
                >
                  <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0 m-1"
                    aria-label="Close"
                    style={{ zIndex: 2, fontSize: "0.8rem" }}
                    onClick={handleCloseFeedback}
                  ></button>
                  {feedbackKey
                    ? pandinItems[feedbackKey] || t(feedbackKey) || feedbackKey
                    : feedbackData}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pandin;
